import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import UnavailablesFullDatePicker from 'components/UnavailablesFullDatePicker';
import EmployeeActions from 'actions/EmployeeActions';
import UnavailableSidebarItem from 'components/UnavailableSidebarItem.js';
import UnavailablesPartialDatePicker from 'components/UnavailablesPartialDatePicker';
import UnavailablesPartialFullDatePicker from 'components/UnavailablesPartialFullDatePicker.js';
import Popover from 'components/popover/Popover.js';

class SidebarTimeOff extends React.Component {
  constructor(props) {
    super(props);

    this.onSuccessfulCreate = this.onSuccessfulCreate.bind(this);
    this.onCreateError = this.onCreateError.bind(this);
    this.onTimeoffClick = this.onTimeoffClick.bind(this);
    this._onClosePopover = this._onClosePopover.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);
    this.onPostTimeoff = this.onPostTimeoff.bind(this);
    this.onTextAreaInput = this.onTextAreaInput.bind(this);
    this.onUnavailTypeSelect = this.onUnavailTypeSelect.bind(this);
    this.datePicker = this.datePicker.bind(this);
    this.startPicker = null;
    this.endPicker = null;

    this.state = {
      popOverActive: false,
      popTarget: null,
      partial: this.initialPartialState(),
      startsAt: null,
      endsAt: null,
      notes: '',
      unavailableTypeId: this.initialUnavailableType(),
      requestError: false,
    };
  }

  // Generic state updater called from children
  // components
  updateStateHandler(name, value) {
    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    const that = this;

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);

    UnavailablesStore.on('unavailables:create:success', this.onSuccessfulCreate);
    UnavailablesStore.on('unavailables:create:error', this.onCreateError);
  }

  componentWillUnmount() {
    UnavailablesStore.off('unavailables:create:success', this.onSuccessfulCreate);
    UnavailablesStore.off('unavailables:create:error', this.onCreateError);

    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  _onClosePopover() {
    this.setState({
      popOverActive: false,
      popTarget: null,
      startsAt: null,
      endsAt: null,
      notes: '',
      unavailableTypeId: this.initialUnavailableType(),
      partial: this.initialPartialState(),
    });
  }

  resetPopover() {
    const buttons = document.querySelectorAll('.btn-group button');

    [].forEach.call(buttons, (button) => {
      button.removeAttribute('disabled');
    });

    const el = document.querySelector('.popovertimeoff');
    const errors = el.querySelectorAll('.error');
    [].forEach.call(errors, (error) => {
      error.classList.remove('error');
    });

    if (!Utils.isNotDefined(this.startPicker)) this.startPicker.setDate(this.props.selectedDate);
    if (!Utils.isNotDefined(this.endPicker)) this.endPicker.setDate(this.props.selectedDate);

    el.removeAttribute('data-shift-replied');

    document.querySelector('span.error-message').innerHTML = '';
    this.setState({
      requestError: false
    })
  }

  onCreateError(response) {
    const errorField = ReactDOM.findDOMNode(this).querySelector('span.error-message');
    errorField.innerHTML = JSON.parse(response.responseText).error_message;
    errorField.parentNode.classList.add('error');
    this.setState({
      requestError: true
    })
  }

  onSuccessfulCreate(collection, id) {
    this.resetPopover();
    this._onClosePopover();
  }

  onTextAreaInput(e) {
    this.setState({ notes: e.target.value });
  }

  onUnavailTypeSelect(e) {
    this.setState({ unavailableTypeId: parseInt(e.target.value) });
  }

  onPostTimeoff(e) {
    const allowConflict = Utils.getCoreUser().company.allow_time_off_request_with_conflict
    if (EmployeeActions) {
      EmployeeActions.postTimeOff(
        this.state.startsAt,
        this.state.endsAt,
        this.state.notes,
        this.state.unavailableTypeId,
        allowConflict ? this.state.partial: this.state.partial || this.props.hideFullDay,
        this.state.requestError ? true : false
      );
    }
  }

  onTimeoffClick(e) {
    const that = this;
    that.resetPopover();

    that.setState({
      notes: '',
      popOverActive: !that.state.popOverActive,
      popTarget: Utils.isNotDefined(e) ? that.state.popTarget : e.target,
      unavailableTypeId: that.initialUnavailableType(),
      partial: that.initialPartialState(),
    });
  }

  initialUnavailableType() {
    if (
      !Utils.isNotDefined(this.props.unavailableTypes)
      && this.props.unavailableTypes.length > 0
    ) {
      return this.props.unavailableTypes[0].id;
    }
    return undefined;
  }

  initialPartialState() {
    if (Utils.getCoreUser().company.time_off_mode === 'partial_day') {
      return true;
    }
    return false;
  }

  // Returns a date/time picker based on
  // the company's time off settings
  datePicker(hideFullDayDatePicker) {
    let mode = Utils.getCoreUser().company.time_off_mode;
    // if there is a partial time off already,
    // hide the full day date pickers
    if (hideFullDayDatePicker) {
      // if conflicts are allowed show both full day and partial day.
      if(Utils.getCoreUser().company.allow_time_off_request_with_conflict) {
        mode = 'full_or_partial_day';
      } else {
        mode = 'partial_day';
      }
    }

    switch (mode) {
      case 'partial_day':
        return (
          <UnavailablesPartialDatePicker
            date={this.props.selectedDate}
            startsAt={this.state.startsAt}
            endsAt={this.state.endsAt}
            startsAtHandler={this.updateStateHandler.bind(this, 'startsAt')}
            endsAtHandler={this.updateStateHandler.bind(this, 'endsAt')}
            partialHandler={this.updateStateHandler.bind(this, 'partial')}
          />
        );
        break;
      case 'full_or_partial_day':
        return (
          <UnavailablesPartialFullDatePicker
            selectedDate={this.props.selectedDate}
            startsAt={this.state.startsAt}
            endsAt={this.state.endsAt}
            partial={this.state.partial}
            partialHandler={this.updateStateHandler.bind(this, 'partial')}
            startsAtHandler={this.updateStateHandler.bind(this, 'startsAt')}
            endsAtHandler={this.updateStateHandler.bind(this, 'endsAt')}
          />
        );
        break;
      default:
        // Default is Full Day Date Picker
        return (
          <UnavailablesFullDatePicker
            defaultDate={this.props.selectedDate}
            startsAtHandler={this.updateStateHandler.bind(this, 'startsAt')}
            endsAtHandler={this.updateStateHandler.bind(this, 'endsAt')}
          />
        );
    }
  }

  formatHours(time) {
    if (time == null) return '';

    return moment(time)
      .tz(Utils.getCoreUser().inferred_time_zone)
      .format('h:mm a');
  }

  render() {
    if (!Utils.isNotDefined(this.startPicker)) this.startPicker.setDate(this.props.selectedDate);
    if (!Utils.isNotDefined(this.endPicker)) this.endPicker.setDate(this.props.selectedDate);
    const today = moment(new Date().setHours(0, 0, 0, 0));

    let unavailableTypes = [];
    const shifts = [];
    let containsFullDayTimeOff = false;

    if (this.props.unavailableTypes && this.props.unavailableTypes.length > 0) {
      unavailableTypes = this.props.unavailableTypes.map(type => (
        <option key={type.id} value={type.id}>
          {type.name}
        </option>
      ));
    }

    // check if selectedDayData has a request
    if (this.props.shiftData && this.props.shiftData.length > 0) {
      const disabled = true;

      // Sort shifts by date first
      const sorted_shifts = this.props.shiftData.sort(
        (a, b) => new Date(a.starts_at) - new Date(b.starts_at),
      );

      for (let i = 0; i < sorted_shifts.length; i++) {
        if (!Utils.isNotDefined(sorted_shifts[i].id)) {
          const item = sorted_shifts[i];
          const request_id = item.unavailable_request_id;
          const request = UnavailablesStore.getAllUnavailableRequestsById(request_id);
          const { unavailable_type_id, source } = item;
          const unavailableType = UnavailablesStore.getUnavailableTypesById(unavailable_type_id);

          let startDate;
          let endDate;
          if (request) {
            startDate = Utils.formatLocaleDate(moment(request.start_date));
            endDate = Utils.formatLocaleDate(moment(request.end_date));
          } else {
            // Issue: https://github.com/AppColony/makeshift/issues/5718
            // Check if partial and UTC starts_at and ends_at days are different
            // otherwise use the date
            const utcStart = moment.utc(item.starts_at);
            const utcEnd = moment.utc(item.ends_at);
            if (item.partial && utcEnd.isSame(utcStart.add(1, 'days'), 'd')) {
              startDate = Utils.formatLocaleDate(moment(item.starts_at));
              endDate = Utils.formatLocaleDate(moment(item.ends_at));
            } else {
              startDate = Utils.formatLocaleDate(moment(item.date));
              endDate = Utils.formatLocaleDate(moment(item.date));
            }
          }

          let notes = '';
          if (typeof item.notes !== 'undefined') {
            notes = item.notes;
          } else if (request.notes) {
            notes = request.notes;
          }

          let unavailableTypeName = '';
          if (unavailableType) {
            unavailableTypeName = unavailableType.name;
          }

          let currentState = request.state;
          if (typeof item.state !== 'undefined') {
            currentState = item.state;
          }

          const { partial } = item;
          let hoursRange = '';
          if (partial) {
            hoursRange = `${this.formatHours(item.starts_at)} - ${this.formatHours(item.ends_at)}`;
          }

          if (!partial) {
            // If one of the unavailables is full-day time off
            // then we hide a bunch of buttons and date pickers
            containsFullDayTimeOff = true;
          }

          let state = '';
          switch (currentState) {
            case 'new':
              state = this.props.t('SidebarTimeOff.pending');
              break;
            case 'approved':
            default:
              state = this.props.t('SidebarTimeOff.approved');
          }

          shifts.push(
            <UnavailableSidebarItem
              key={`${item.id}-${state}`}
              id={item.id}
              requestId={item.unavailable_request_id}
              state={state}
              typeName={unavailableTypeName}
              startDate={startDate}
              endDate={endDate}
              hoursRange={partial ? hoursRange : ''}
              notes={notes}
              state={currentState}
              displayedState={state}
              source={source}
            />,
          );
        }
      }
    }

    const classes = 'calendar-input time-off';

    // Hide everything if there are no unavailables:
    // 1. And Before today
    // 2. Or the create button is disabled
    // 3. Or the company has disabled time off requests
    const hideEverything = (
      shifts.length == 0 &&
      (moment(this.props.selectedDate).isBefore(today)
      || this.props.hideCreateButton
      || !Utils.getCoreUser().company.allow_time_off_requests)
    );
    
    if (hideEverything) {
      return <div />;
    }

    let timeOffCreateButton;
    if (
      moment(this.props.selectedDate).isBefore(today)
      || containsFullDayTimeOff
      || this.props.hideCreateButton
      || !Utils.getCoreUser().company.allow_time_off_requests
    ) {
      timeOffCreateButton = '';
    } else {
      timeOffCreateButton = (
        <button
          className="calendar-input-button create-timeoff-button"
          onClick={this.onTimeoffClick}
        >
          {this.props.t('SidebarTimeOff.create_request')}
        </button>
      );
    }

    const containsPartialTimeOff = !containsFullDayTimeOff && shifts.length > 0;

    return (
      <div>
        <div className={classes}>
          <span className="calendar-input-bullet timeoff-bullet">{this.props.t('SidebarTimeOff.time_off')}</span>
          {shifts.length > 0 && (
            <div className="data-list timeoff-requests">
              <ul>{shifts}</ul>
            </div>
          )}
          {timeOffCreateButton}
        </div>
        <Popover
          onHide={e => this._onClosePopover(e)}
          position="right"
          className="popovertimeoff"
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
        >
          <h3>{this.props.t('SidebarTimeOff.time_off_request')}</h3>
            <form id="timeoffFormContainer">
            <div>
            {this.datePicker(containsPartialTimeOff || this.props.hideFullDay)}
            <div>
              <label htmlFor="timeoffTypes">{this.props.t('SidebarTimeOff.time_off_type')}</label>
              <div className="styledSelect">
                <select
                  id="timeoff-unavailable-type"
                  onChange={this.onUnavailTypeSelect}
                  value={this.state.unavailableTypeId}
                  >
                  {unavailableTypes}
                </select>
              </div>
            </div>
            <label htmlFor="timeoffNote">{this.props.t('SidebarTimeOff.note_optional')}</label>
            <textarea
              id="timeoffNote"
              name="timeoffNote"
              placeholder=""
              maxLength="254"
              value={this.state.notes}
              onChange={this.onTextAreaInput}
              />
              </div>
            <span className="error-message" />
          </form>
          <div className="btn-group pull--right">
            <button
              className="button button--inline timeoff-cancel-button"
              onClick={this.onTimeoffClick}
            >
              {this.props.t('SidebarTimeOff.close')}
            </button>
            <button
              className="button button--recommended button--inline timeoff-post-button"
              onClick={this.onPostTimeoff}
            >
              {this.props.t('SidebarTimeOff.send_request')}
            </button>
          </div>
        </Popover>
      </div>
    );
  }
}

export default translate()(SidebarTimeOff);
